//# sourceMappingURL=my-date.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-mydatepicker/dist/interfaces/my-date.interface.js
// module id = 433
// module chunks = 4